import { POSTNEW, EXPORTNEW, GETNEW, POSTFormDataNEW } from '@/request/http'

// 毕业生退寝计划分页列表
export const getLeavingBedPlanTableData = p => POSTNEW('/dormv2/dormRetreatPlan/page', p)

// 毕业生退寝计划创建和修改
export const createdLeavingBedPlan = p => POSTNEW('/dormv2/dormRetreatPlan/saveOrUpdate', p)

// 完成毕业生退寝计划
export const changeLeavingBedPlanStatus = p => POSTNEW('/dormv2/dormRetreatPlan/updatePlanStatus', p)

// 毕业生退寝计划详情
export const editLeavingBedPlan = p => GETNEW('/dormv2/dormRetreatPlan/getDetailById', p)

// 毕业生退寝获取导入学生分页
export const getLeavingBedImportStudentTableData = p => POSTNEW('/dormv2/dormNameList/page', p)

// 批量删除导入学生
export const delLeavingBedImportStudent = p => POSTNEW('/dormv2/dormNameList/removeList', p)

// 毕业生退寝学生导入提交
export const leavingBedStudentSubmitImport = p => POSTFormDataNEW('/dormv2/dormNameList/importNameList', p)

// 毕业生退寝学生导入所需scopeValue
export const getLeavingBedImportStudentScopeValue = p => GETNEW('/dormv2/dormNameList/guidd', p)

// 手动添加学生分页列表
export const getAddLeavingBedStudentTableData = p => POSTNEW('/dormv2/dormNameList/pageStudent', p)

// 手动添加学生提交
export const submitAddLeavingBedStudent = p => POSTNEW('/dormv2/dormNameList/saveList', p)

// 毕业生退寝详情分页列表
export const getLeavingBedDetailTableData = p => POSTNEW('/dormv2/dormRetreat/page/{screenCode}', p)

// 毕业生退寝详情统计
export const getLeavingBedDetailStatic = p => POSTNEW('/dormv2/dormRetreat/getCountNum/{screenCode}', p)

// 推迟退寝
export const submitDelayLeaveBed = p => POSTNEW('/dormv2/dormRetreat/delayRetreatDorm', p)

// 退寝
export const submitLeaveBed = p => POSTNEW('/dormv2/dormRetreat/retreatDorm', p)

// 导出
export const leaveBedExport = p => EXPORTNEW('/dormv2/dormRetreat/export/{screenCode}', p)

// 选择使用毕业生档案调用接口
export const isGraduateFileradioChange = p => POSTNEW('/dormv2/dormNameList/insertGraduaStudent', p)

// 删除退寝学生
export const delLeaveBedStudent = p => POSTNEW('/dormv2/dormRetreat/deleteById', p)


// WEBPACK FOOTER //
// ./src/api/modules/graduatesLeavingBed.js